import React from 'react';
import './App.css';
import Login from './component/Login/Login';

function App() {
  return (
    <div className="App">
      <Login></Login>
    </div>
  );
}

export default App;
